import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "M10 .5a9.5 9.5 0 0 1 9.5 9.5 9.5 9.5 0 0 1-9.5 9.5A9.5 9.5 0 0 1 .5 10 9.5 9.5 0 0 1 10 .5Zm0 .25C4.9.75.75 4.9.75 10S4.9 19.25 10 19.25s9.25-4.15 9.25-9.25S15.1.75 10 .75Zm-1.25 8.5H10c.068 0 .125.057.125.125v4.875h1.75a.125.125 0 0 1 0 .25h-3.75A.127.127 0 0 1 8 14.375c0-.068.057-.125.125-.125h1.75V9.5H8.75a.127.127 0 0 1-.125-.125c0-.068.057-.125.125-.125ZM10 5.812a.438.438 0 1 1 0 .876.438.438 0 0 1 0-.875Z"
    }, null, -1)
  ])))
}
export default { render: render }